/**
 * Builds select options for people custom fields from family parent profiles.
 */
import type { Profile } from "@spork/s4p-server-sdk";

import type { SelectOption } from "@/components/ui/enum-select";
import { useGetProfilesQuery } from "@/query/apiSlice";

import { getProfileLabel } from "./formatProfileSummary";

export function getParentSelectOptions(
    profiles: Profile[] | undefined,
): SelectOption[] {
    return [...(profiles ?? [])]
        .filter((profile) => profile.role === "parent")
        .map((profile) => ({
            id: profile.id,
            label: getProfileLabel(profile),
        }))
        .sort((left, right) => left.label.localeCompare(right.label));
}

export function useParentSelectOptions(): SelectOption[] {
    const { data: profiles } = useGetProfilesQuery();
    return getParentSelectOptions(profiles);
}
